import React, { Component } from "react";
import moment from 'moment';
import { withStyles, Grid, Fade, CircularProgress, ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, Divider, LinearProgress} from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Paper from '@material-ui/core/Paper';
import { Color } from "../../Constants";
import EnhancedTableToolbar from "../../components/EnhancedTableToolbar";
import { DeliveryService } from "../../Services/DeliveryService";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from "@material-ui/core/styles";
import XLSX from 'xlsx';

const styles = theme =>({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
      marginTop: theme.spacing(3)
    },
    tablecell: {
        fontSize: '30pt',
        padding: 2
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
        float: 'left'
    },
    section: {
		width: '100%',
		minHeight: 400,
		overflow: 'auto',
		overflowX: 'auto',
		paddingTop : theme.spacing(1), 
		paddingLeft: theme.spacing(1), 
		paddingRight: theme.spacing(1),
		paddingBottom: theme.spacing(1)
    },
    table: {
        height: 300,
        overflow: 'auto'
    }, 
    selectRoot: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
    heading: {
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightRegular,
    },
  });

class StoreShelfStats extends Component {

    constructor(props) {
      super(props);
      this.state = {       
        startDate: moment(),
        showSpinner: false,
        rows: [],
        data: [],
        exportLoading: false
      }
    }

    componentDidMount(){
        this.props.setTitle('Store Shelf Report');
        this.setState({showSpinner: true}, () => this.fetchData());
    }

    handleChangeStartDate = (date) => {
        if(date !== this.state.startDate){
            this.setState({
                startDate: date,
            }, () => this.fetchData());
        }
    }

    fetchData = () => {
        let {startDate} = this.state;
        this.setState({showSpinner: true});
        let rows = [];

        DeliveryService.getStoreShelfStats(startDate)
        .then((data) => {
            console.log(data);
            if(data.rows && data.rows.length > 0){
                let storeMap = new Map();
                data.rows.forEach((row) => {
                    let a = {};
                    if(storeMap.has(row.store_id)){
                        a = storeMap.get(row.store_id);
                    } else {
                        a.store_id = row.store_id;
                        a.store_name = row.store_name;
                        a.balance_count = 0;
                        a.delivered_count = 0;
                        a.returned_count = 0;
                        a.product_list = [];
                        storeMap.set(a.store_id, a);
                    }
                    a.balance_count += row.balance_count;
                    a.delivered_count += row.delivered_count > 0 ? row.delivered_count : 0;
                    a.returned_count += row.returned_count > 0 ? row.returned_count : 0;
                    a.product_list.push(row);
                });
                let index = 1;
                storeMap.forEach((value, key, map) => {
                    rows.push(<StoreDetails index={index++} key={key} store={value} />);
                });
            }
            this.setState({showSpinner: false, data: data.rows, rows, message: data.rows.length > 0 ? "" : "No Delivery information available"});
        })
        .catch(error => {
            console.log(error);
            this.setState({showSpinner: false, message: "Failed to fetch delivery details. Check internet connection and retry."});
        });
    }

    exportReport = () => {
        let data = this.state.data;
        this.setState({exportLoading: true});
        if(data && data.length > 0){
            let sheetname = 'Store Shelf Report';
            let exportData = [];
            exportData = [["Sl No", "Store", "Agent", "Route", "Product", "Min Qty", "Returned Count", "Balance Count", "Delivered Count"]];
            data.forEach((row, index) => {
                    exportData.push([index+1, row.store_name, row.agent_name, row.route_id, row.product_name, row.min_qty, row.returned_count, row.balance_count, row.delivered_count]);
            });

            if(exportData){
                const wb = XLSX.utils.book_new();
                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.writeFile(wb, sheetname + ".xlsx");
            }
            this.setState({exportLoading: false});
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
            this.setState({exportLoading: false});
        }
    }
    
    render() {
        let { startDate, message, showSpinner, rows, exportLoading} = this.state;
        const { classes } = this.props;
        return ( 
            <div className="Home">
                <Paper className={classes.root} style={{ paddingLeft: "5px", paddingRight: "5px", marginTop: 32, minHeight: 250}}>
                    <Grid container spacing={1} style={{marginTop: 20}}>
                        <Grid item container xs={12} lg={12}>
                            <Grid item xs={8} lg={12}>
                                <EnhancedTableToolbar title={
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="dialog"
                                            margin="normal"
                                            label="Selected Date"
                                            value={startDate}
                                            onChange={this.handleChangeStartDate}
                                            format='DD MMM YYYY'
                                            maxDate={moment().add(1, 'day')}
                                            inputVariant="outlined"
                                            className={classes.formControl}
                                        />
                                    </MuiPickersUtilsProvider>
                                } exportReport={this.exportReport} showProgress loading={exportLoading}/>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {rows}
                            {message}
                        </Grid>
                    </Grid>
                    <Fade
                    key="spinner"
                    in={showSpinner}
                    style={{
                        transitionDelay: showSpinner ? '10ms' : '0ms',
                        position: 'absolute', left: '50%', top: '60%'
                    }}
                    unmountOnExit
                    >
                    <CircularProgress style={{marginTop: 20, color: Color.green}} color="inherit" size={60}/>
                    </Fade>
                </Paper>
            </div>
        );
    }
}

const useStyles = makeStyles(theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(13),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    }
}));

function StoreDetails(props){

    const {store, index} = props;
    
    const classes = useStyles();

    const [details, setDetails] = React.useState([]);

    const [open, setOpen] = React.useState(false);

    const [loading, setLoading] = React.useState(false);

    const balance = store.product_list.reduce(function(accumulator, currentValue) {
        return accumulator + (currentValue.balance_count > 0 ? currentValue.balance_count : 0);
    }, 0);

    const delivered = store.product_list.reduce(function(accumulator, currentValue) {
        return accumulator + (currentValue.delivered_count > 0 ? currentValue.delivered_count : 0);
    }, 0);

    const returned = store.product_list.reduce(function(accumulator, currentValue) {
        return accumulator + (currentValue.returned_count > 0 ? currentValue.returned_count : 0);
    }, 0);

    let summary_rows = [];
    summary_rows.push(
            <Grid item key={1} xs={12} lg={2}>
                <Typography className={classes.subheading}>Total items on Shelf: {balance}</Typography>
            </Grid>
    );
    summary_rows.push(
        <Grid item key={2} xs={12} lg={2}>
            <Typography className={classes.subheading}>Total returned: {returned}</Typography>
        </Grid>
    );
    summary_rows.push(
        <Grid item key={3} xs={12} lg={2}>
            <Typography className={classes.subheading}>Total count delivered: {delivered}</Typography>
        </Grid>
    );
   
    React.useEffect(() => {
        if(open && store.product_list.length > 0){
            setLoading(true);
                    let rows = store.product_list.map((row, i) => {
                        return(
                            <Grid item container xs={12} lg={12} key={index} spacing={2} >
                                <Grid item xs={12} lg={2}>
                                    <Typography className={classes.subheading} style={{textAlign: 'left'}}>Product: {row.product_name}</Typography>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <Typography className={classes.subheading} style={{textAlign: 'left'}}>Minimum required on shelf: {row.min_qty}</Typography>
                                </Grid>
                                <Grid item xs={12} lg={3}>
                                    <Typography className={classes.subheading} style={{textAlign: 'left'}} color="textSecondary">Remained on Shelf: {row.balance_count < 0 ? 'Not available' : row.balance_count }</Typography>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <Typography className={classes.subheading} style={{textAlign: 'left'}} color="secondary">Returned: {row.returned_count < 0 ? 'No delivery attempt made' : row.returned_count }</Typography>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <Typography className={classes.subheading} style={{textAlign: 'left'}} color="primary">Delivered: {row.delivered_count < 0 ? 'No delivery attempt made' : row.delivered_count }</Typography>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Divider variant="fullWidth" style={{marginBottom: 10}}/>
                                </Grid>
                            </Grid>
                        )
                    });
                    setDetails(rows);
                    setLoading(false);
        }

    }, [open]);
    
    return (
        <ExpansionPanel onClick={() => setOpen(true)}>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"  
                >
                <Grid container justify="flex-start" alignItems="center" direction="row">
                    <Grid item xs={12} lg={1}>
                        <Typography className={classes.heading}>{index}</Typography>
                    </Grid>
                    <Grid item xs={12} lg={5}>
                        <Typography className={classes.heading} style={{textAlign: "left", paddingLeft: 5}}>{store.store_name}</Typography>
                    </Grid>
                    {summary_rows}
                </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <Divider variant="middle"/>
                <Grid container justify="flex-start" alignItems="center" direction="row">
                    <Grid item xs={12} lg={12}>
                        <Fade
                            in={loading}
                            style={{
                                transitionDelay: loading ? '10ms' : '0ms'
                            }}
                            unmountOnExit
                            >
                            <LinearProgress style={{height: 5, width: "100%"}} color="secondary"/>
                        </Fade>
                    </Grid>
                    {details}
                </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}

export default withStyles(styles)(StoreShelfStats);